import request from '@/api';

// 获取设备列表
export function getDeviceList(params) {
  return request({
    url: '/web/account/device/list',
    method: 'get',
    params
  });
}

// 获取设备绑定历史
export function getDeviceHistory(deviceId) {
  return request({
    url: `/web/account/device/history/${deviceId}`,
    method: 'get'
  });
}

// 获取设备数据统计
export function getDeviceStatistics(deviceId) {
  return request({
    url: `/web/account/device/statistics/${deviceId}`,
    method: 'get'
  });
}

// 绑定设备
export function bindDevice(data) {
  return request({
    url: '/web/account/device/bind',
    method: 'post',
    data
  });
}

// 解绑设备
export function unbindDevice(data) {
  return request({
    url: '/web/account/device/unbind',
    method: 'post',
    data
  });
}

// 转移设备
export function transferDevice(data) {
  return request({
    url: '/web/account/device/transfer',
    method: 'post',
    data
  });
}

// 获取检测员列表
export function getInspectorList(params) {
  return request({
    url: '/web/account/inspector/list',
    method: 'get',
    params
  });
}

// 获取操作日志列表
export function getOperationLogList(params) {
  return request({
    url: '/web/account/device/operation-log',
    method: 'get',
    params
  });
}

// 导出操作日志
export function exportOperationLog(params) {
  return request({
    url: '/web/account/device/operation-log/export',
    method: 'get',
    params,
    responseType: 'blob'
  });
}

// 导出设备历史数据
export function exportDeviceData(params) {
  return request({
    url: '/web/account/device/export-data',
    method: 'get',
    params,
    responseType: 'blob'
  });
}
